/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
    REQUEST_GROUP_DEVICES,
    REQUEST_GROUPS, 
    REQUEST_GROUP_PROFILES,
    REQUEST_DEVICE_BY_DEVICEID
} from './actionTypes'
import {
    call,
    put,
    takeEvery,
  } from 'redux-saga/effects'

  import { Groups as groupApi } from './groups'
import {
    fetchGroupsSuccess,fetchGroupsFailure,
    fetchGroupProfilesFailure,fetchGroupProfilesSuccess,
    fetchGroupDevicesFailure,fetchGroupDevicesSuccess,
    fetchDeviceByDeviceIdSuccess,fetchDeviceByDeviceIdFailure
   
} from './actions'


function* fetchGroupsForSaga(action){
    try{
      const response = yield call(groupApi.getGroups,action.options, action.groupId)
      yield put(fetchGroupsSuccess(response.data))
    }catch(error){
        yield put(fetchGroupsFailure(error));
    }
}

export function* groupRequestSaga() {
    yield takeEvery(REQUEST_GROUPS, fetchGroupsForSaga);
}

function* fetchGroupProfilesForSaga(action){
    try{
        const response = yield call(groupApi.getGroupProfiles,action.options, action.groupId);
        yield put(fetchGroupProfilesSuccess(response.data))
    }catch(error){
        yield put(fetchGroupProfilesFailure(error));
    }
}

export function* profileRequestSaga() {
    yield takeEvery(REQUEST_GROUP_PROFILES, fetchGroupProfilesForSaga);
}

function* fetchDevicesForSaga(action){
    try{
        const response = yield call(groupApi.getGroupDevices, action.options, action.groupId);
        yield put(fetchGroupDevicesSuccess(response.data))
    }catch(error){
        yield put(fetchGroupDevicesFailure(error));
    }
}

export function* deviceRequestSaga() {
    yield takeEvery(REQUEST_GROUP_DEVICES, fetchDevicesForSaga);
}

function* fetchDeviceByDeviceId(action){
    try{
      const response = yield call(groupApi.getDeviceByDeviceId,action.deviceId,action.profileId)
      yield put(fetchDeviceByDeviceIdSuccess(response.data))
    }catch(error){
        yield put(fetchDeviceByDeviceIdFailure(error));
    }
}

export function* deviceByDeviceIdRequestSaga() {
    yield takeEvery(REQUEST_DEVICE_BY_DEVICEID,fetchDeviceByDeviceId);
}

